import { SACRAMENT_TRACKING } from "Flocknote/GlobalComponents/Modal/contentKeys";
import flocknoteStateHooks from "Flocknote/stateHooks";

import { useRefreshBoardData } from "Boards/AddColumn/useRefreshBoardData";
import { sacramentsConfig } from "SacramentTracking/sacramentsConfig";

export function useOpenSacramentModal({
  defaultFieldTypeInstanceMapping,
  targetUserID,
  networkFieldID,
}) {
  const [, { openModal }] = flocknoteStateHooks.useModal();
  const { refreshBoardData } = useRefreshBoardData({
    onSuccess: () => {},
    onError: () => {
      console.log("failed to get or update board data");
    },
  });

  const getSacramentKey = () => {
    let key;

    for (const [sacramentKey, value] of Object.entries(sacramentsConfig)) {
      for (const [, fieldValue] of Object.entries(value.fields)) {
        if (fieldValue.name === defaultFieldTypeInstanceMapping) {
          key = sacramentKey;
        }
      }
    }

    return key;
  };

  const foundSacramentKey = getSacramentKey();

  const openSacramentModal = () => {
    if (!foundSacramentKey) return;

    openModal(SACRAMENT_TRACKING, {
      sacrament: foundSacramentKey,
      targetUserID,
      networkFieldID,
      onClose: refreshBoardData,
    });
  };
  return { openSacramentModal };
}
